import React from "react";
import classnames from "classnames";
import PropTypes from "prop-types";

import styles from "./Badge.css";

const Badge = ({ children, isGray, isSmall }) => (
  <div
    className={classnames(styles.root, {
      [styles.small]: isSmall,
      [styles.gray]: isGray,
    })}
  >
    {children}
  </div>
);

Badge.propTypes = {
  children: PropTypes.string.isRequired,
  isSmall: PropTypes.bool,
  isGray: PropTypes.bool,
};

export default Badge;
